import analyticsUtils from '../analytics-utils'

const productAddToCart = (product, opts) => {
  analyticsUtils.gaTagTracking({
    event: analyticsUtils.events.PRODUCTS_BUY_NOW,
    ecommerce: {
      add: {
        products: [
          {
            name: product.name,
            id: product.objectId,
            category: product.primaryCategory,
            brand: product.brand,
            price: (product.salePrice || product.price) / 100,
            position: 1,
            dimension79: product.retailer.retailerCode,
            dimension87: product.retailer.name,
          },
        ],
      },
    },
    ...opts,
  })
}

export default productAddToCart
